<!-- <div id="calendar"></div> -->
<!-- <app-schedule-and-instant></app-schedule-and-instant> -->
  <!-- <app-dashboard [deviceXs] = "deviceXs"></app-dashboard> -->
  <!--<app-login-page *ngIf = "loginPageDisable" (loginPage) = "getLoginValue($event)"></app-login-page>
  <app-layout *ngIf = "layoutShow" [deviceXs] = "deviceXs" [deviceSm] = "deviceSm" [deviceMd] = "deviceMd" [deviceLg] = "deviceLg" [deviceXl] = "deviceXl"></app-layout>
  -->
  <router-outlet  *ngIf="!show"></router-outlet>
  <notifier-container  *ngIf="show"></notifier-container>
  <!-- <router-outlet></router-outlet> -->
<!-- <router-outlet></router-outlet>  -->
 <app-layout *ngIf="show" [deviceXs] = "deviceXs" [deviceSm] = "deviceSm" [deviceMd] = "deviceMd" [deviceLg] = "deviceLg" [deviceXl] = "deviceXl"></app-layout>
 <!-- <app-footer></app-footer> -->
 <!-- <ngx-spinner
 bdColor="rgba(51, 51, 51, 0.8)" size="medium" type="ball-scale-multiple" >
  <p [ngStyle]="{'font-size':'16px', 'color':'rgb(240, 247, 240)'}">Loading...!</p>
</ngx-spinner> -->
<ngx-spinner
bdColor="rgba(51, 51, 51, 0.8)" size="medium" type="ball-scale-multiple" >
 <p [ngStyle]="{'font-size':'16px', 'color':'rgb(240, 247, 240)'}">Please wait...!</p>
</ngx-spinner>
